import { useState } from "react";
import { createPortal } from "react-dom";
import { Theme } from "../Theme.js";
import ExploreRelationships from "./ExploreRelationships.js";

export default function Resources({ setCurrentView, signedInAs, sidebarOpen }) {
  const [showPopup, setShowPopup] = useState(false);

  const containerStyle = {
    ...Theme.layout.page,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    paddingTop: "0px",
  };

  const cardsWrapper = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, 350px)",
    justifyContent: "center",
    gap: "20px",
    width: "100%",
    maxWidth: "900px",
  };

  const cardStyle = {
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "20px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "350px",
  };

  const titleStyle = { margin: "0 0 8px 0", fontSize: "18px" };
  const descStyle = { margin: "0 0 16px 0", color: "#333" };
  const buttonStyle = {
    padding: "10px 20px",
    marginTop: "8px",
    backgroundColor: "#0067B3",
    color: "#fff",
    border: "none",
    borderRadius: "999px",
    cursor: "pointer",
    fontSize: "15px",
    width: "300px",
    alignSelf: "center",
  };

  const closeButtonStyle = {
    ...buttonStyle,
    width: "160px",
    padding: "8px 16px",
    fontSize: "14px",
  };
  const tpopupStyle = {
    position: "relative",
    backgroundColor: "#fff",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
    zIndex: 2001,
    width: "320px",
    maxWidth: "90%",
    textAlign: "left",
  };

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: sidebarOpen ? 280 : 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    zIndex: 2000,
    display: "grid",
    placeItems: "center",
    padding: 16,
    boxSizing: "border-box",
  };

  return (
    <div style={containerStyle}>
      <div style={{ width: 350, minWidth: 300 }}>
        <img
          src={(process.env.PUBLIC_URL || "") + "/Icon-RS-Blue.png"}
          alt="Logo"
          style={{
            width: "100%",
            maxWidth: 200,
            height: "auto",
            display: "block",
            margin: "auto auto 30px auto",
          }}
        />
      </div>
      <div style={cardsWrapper}>
        <div style={cardStyle}>
          <div>
            <h2 style={titleStyle}>Wholistic Health Program ©</h2>
            <p style={descStyle}>
              Complete the Wholistic Health Program © through 10 transformative
              and practical exercises.
            </p>
          </div>
          <button
            style={buttonStyle}
            onClick={() => setCurrentView?.("WholisticHealthProgram")}
          >
            View Program
          </button>
        </div>

        <div style={cardStyle}>
          <div>
            <h2 style={titleStyle}>How To Videos / User Manual</h2>
            <p style={descStyle}>
              Step-by-step video guides to help you get started and continue
              your journey.
            </p>
          </div>
          <button
            style={buttonStyle}
            onClick={() =>
              window.open(
                "https://www.youtube.com/playlist?list=PLPUoai1c7t6cMlOlEaEUUOTRWH1VSS8au",
                "_blank",
              )
            }
          >
            View How-To Videos
          </button>
        </div>

        {signedInAs === "Professional" && (
          <div style={cardStyle}>
            <div>
              <h2 style={titleStyle}>Explore Relationships</h2>
              <p style={descStyle}>
                See insights regarding how health outcomes statistically affect
                other outcomes.
              </p>
            </div>
            <button style={buttonStyle} onClick={() => setShowPopup(true)}>
              Explore
            </button>
          </div>
        )}
      </div>

      {/* Popup */}
      {showPopup &&
        typeof document !== "undefined" &&
        createPortal(
          <>
            <div style={overlayStyle} onClick={() => setShowPopup(false)}>
              <div
                style={{
                  width: "min(1200px, 95vw)",
                  boxSizing: "border-box",
                  zIndex: 2001,
                  maxHeight: "90vh",
                  overflowY: "auto",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  style={{
                    ...tpopupStyle,
                    padding: 0,
                    background: "#fff",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      padding: "16px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <h3 style={{ margin: 0 }}>Relationship Explorer</h3>

                    <button
                      style={closeButtonStyle}
                      onClick={() => setShowPopup(false)}
                    >
                      Close
                    </button>
                  </div>

                  <div style={{ padding: "16px" }}>
                    <ExploreRelationships />
                  </div>
                </div>
              </div>
            </div>
          </>,
          document.body,
        )}
    </div>
  );
}
